import React, { useState } from "react";
// import MainImage from "../../assets/HeroImages/MainPot10.jpg";
import MainImage from "../../../assets/HeroImages/MainPot10.jpg";
import Footer from "../../../components/Footer";
import Navbar from "../../../components/Navbar";
import PastWork from "../../../components/PastWord"; // Assuming this component exists
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline"; // Import icons
import FirstStep from "../../../components/FirstStep";
import About from "../../../components/About";
import FeatureImage from "../../../assets/AboutImage1.jpg"; // Replace with your actual image

function AccordionItem({ title, children, isOpen, onToggle }) {
  const firstSentence = React.Children.toArray(children).find(
    (child) => typeof child === "string" || (React.isValidElement(child) && child.type === "p")
  );

  const previewText =
    typeof firstSentence === "string"
      ? firstSentence.split(".")[0] + "."
      : React.isValidElement(firstSentence) && firstSentence.type === "p"
      ? React.Children.toArray(firstSentence.props.children)
          .join("")
          .split(".")[0] + "."
      : "";

  const restOfChildren = React.Children.toArray(children).slice(
    firstSentence ? 1 : 0
  );

  return (
    <div className="bg-white rounded-lg shadow-md mb-6">
      <div className="p-6">
        <button
          type="button"
          className="flex items-center justify-between w-full text-left focus:outline-none"
          onClick={onToggle}
        >
          <h3 className="text-xl font-semibold text-neutral-800">{title}</h3>
          {isOpen ? (
            <ChevronUpIcon className="h-5 w-5 text-neutral-600" />
          ) : (
            <ChevronDownIcon className="h-5 w-5 text-neutral-600" />
          )}
        </button>
        {!isOpen && previewText && (
          <p className="text-neutral-700 leading-relaxed mt-2 text-sm italic">
            {previewText}
          </p>
        )}
      </div>
      {isOpen && (
        <div className="p-6 border-t border-neutral-200 text-neutral-700">
          {firstSentence}
          {restOfChildren}
        </div>
      )}
    </div>
  );
}

function Blog2Signs() {
  const [openItem, setOpenItem] = useState(null);

  const toggleAccordion = (title) => {
    setOpenItem(openItem === title ? null : title);
  };

  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F7F3F2]">
      <title>5 Signs Your Women-Owned Business Website Needs a Redesign | YourBrand</title>
      <meta
        name="description"
        content="Is your women-owned business website underperforming? Discover 5 key signs it's time for a redesign and how our Austin-based team can help you attract more clients."
      />
      <meta
        name="keywords"
        content="Website Redesign, Women-Owned Business Website, Outdated Website, Underperforming Website, Website Redesign Signs, Web Design Austin, Austin Website Redesign, Small Business Website Redesign, Improve Website, Website Issues, Dated Website Design, Poor User Experience (UX) Website, High Website Bounce Rate, Low Website Engagement, Not Mobile-Friendly Website, Responsive Web Design Austin, Low Lead Generation Website, Website Not Converting Leads, Brand Disconnect Website, Slow Loading Website, Signs my business website needs a redesign, How to tell if my website is outdated Austin, Why is my women-owned business website bounce rate high?, Website not mobile-friendly hurting my business, Improve website lead generation for women entrepreneurs, Website redesign for better conversions Austin, My website doesn't reflect my brand anymore, Cost of website redesign Austin small business, Benefits of website redesign for women-owned businesses, Website design services for women entrepreneurs Austin"
      />

      <section className="bg-[#F7F3F2]">
        <div
          className="relative h-auto bg-cover bg-top"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
            backgroundImage: `url(${MainImage})`,
            padding: "20px",
            width: "100%",
          }}
        >
          <Navbar />
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex items-center justify-center">
              <h1 className="text-black italic text-3xl max-w-96 font-semibold text-center bg-[#CFF098] py-2 px-4 rounded-md">
                Is It Time? 5 Signs Your Website Needs a Redesign
              </h1>
            </div>
          </div>
        </div>

        <section className="bg-[#F7F3F2] py-16 md:py-24">
          <div className="mx-auto w-full max-w-7xl px-5 md:px-10">
            <div className="flex flex-col items-center text-center mb-16">
              <h2 className="text-3xl font-semibold md:text-4xl text-neutral-800 max-w-4xl uppercase tracking-wide">
                5 Signs Your Women-Owned Business Website Needs a Redesign
              </h2>
              <div className="w-16 h-1 bg-[#CFF098] mt-4 rounded-full"></div>
              <p className="mt-6 max-w-3xl text-lg text-neutral-700 font-light leading-relaxed">
                As a fellow woman entrepreneur here in Austin, you pour your heart and soul into your business. Your website should be a powerful reflection of that passion and a magnet for your ideal clients. But how do you know if your current online presence is helping or hindering your growth? Let's explore 5 crucial signs it might be time for a website redesign.
              </p>
            </div>

            <div className="flex flex-col gap-6 mb-12">
              <AccordionItem
                title="Sign 1: Your Website Looks Dated"
                isOpen={openItem === "Sign 1"}
                onToggle={() => toggleAccordion("Sign 1")}
              >
                <p className="text-neutral-700 leading-relaxed mb-4">
                  Think clunky navigation, outdated color schemes, or a design that doesn't look quite right on mobile. In today's visually driven world, a dated website can erode trust and make potential clients think your business is also behind the times.
                </p>
                <p className="text-neutral-700 leading-relaxed mb-4">
                  A modern, professional design not only looks great but also provides a seamless user experience, encouraging visitors to explore further and engage with your content.
                </p>
                <p className="text-sm text-neutral-500 italic">
                  First impressions matter online just as much as they do in person.
                </p>
              </AccordionItem>

              <AccordionItem
                title="Sign 2: Low Engagement and High Bounce Rate"
                isOpen={openItem === "Sign 2"}
                onToggle={() => toggleAccordion("Sign 2")}
              >
                <p className="text-neutral-700 leading-relaxed mb-4">
                  Are visitors landing on your site and quickly leaving? A high bounce rate and low engagement (time spent on page, pages visited) are strong indicators that your website isn't resonating with your audience.
                </p>
                <p className="text-neutral-700 leading-relaxed mb-4">
                  This could be due to poor navigation, irrelevant content, slow loading times, or a confusing user journey. A redesign focused on user experience can significantly improve these metrics.
                </p>
                <p className="text-sm text-neutral-500 italic">
                  If your website isn't keeping visitors interested, it's not working hard enough for you.
                </p>
              </AccordionItem>

              <AccordionItem
                title="Sign 3: It's Not Mobile-Friendly"
                isOpen={openItem === "Sign 3"}
                onToggle={() => toggleAccordion("Sign 3")}
              >
                <p className="text-neutral-700 leading-relaxed mb-4">
                  In our on-the-go world, a website that doesn't look and function flawlessly on smartphones and tablets is losing out on a massive segment of potential clients right here in Austin and beyond.
                </p>
                <p className="text-neutral-700 leading-relaxed mb-4">
                  Google also prioritizes mobile-friendly websites in its search rankings. A responsive design adapts seamlessly to different screen sizes, ensuring a positive experience for all users.
                </p>
                <p className="text-sm text-neutral-500 italic">
                  Mobile-friendliness is no longer a luxury; it's a necessity.
                </p>
              </AccordionItem>

              <AccordionItem
                title="Sign 4: Your Website Isn't Generating Leads"
                isOpen={openItem === "Sign 4"}
                onToggle={() => toggleAccordion("Sign 4")}
              >
                <p className="text-neutral-700 leading-relaxed mb-4">
                  Your website should be a powerful lead generation tool. If it's not attracting inquiries, capturing email addresses, or guiding potential clients towards a sale, it's underperforming.
                </p>
                <p className="text-neutral-700 leading-relaxed mb-4">
                  A strategic redesign can incorporate clear calls-to-action, optimized lead capture forms, and a user journey designed to convert visitors into valuable leads for your business.
                </p>
                <p className="text-sm text-neutral-500 italic">
                  A website that doesn't generate leads is like a storefront with no door.
                </p>
              </AccordionItem>

              <AccordionItem
                title="Sign 5: It Doesn't Reflect Your Current Brand"
                isOpen={openItem === "Sign 5"}
                onToggle={() => toggleAccordion("Sign 5")}
              >
                <p className="text-neutral-700 leading-relaxed mb-4">
                  Has your business evolved? Have your services expanded or your target audience shifted? Your website should accurately represent your current brand identity, values, and offerings.
                </p>
                <p className="text-neutral-700 leading-relaxed mb-4">
                  An outdated design or messaging can create a disconnect and confuse potential clients. A redesign ensures your online presence aligns perfectly with your brand's present and future.
                </p>
                <p className="text-sm text-neutral-500 italic">
                  Your website is the digital face of your brand; make sure it's saying the right things.
                </p>
              </AccordionItem>
            </div>

            {/* How We Can Help Section */}
            <div className="mt-16 py-12 rounded-lg shadow-md p-8 bg-white border border-neutral-200 relative overflow-hidden">
              <h2 className="text-2xl font-semibold text-neutral-800 text-center mb-6 uppercase tracking-wide">
                Ready for a Website That Works for You?
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-xl font-semibold text-neutral-700 mb-4">How Zilker Web Design Can Help Your Austin Business</h3>
                  <p className="text-neutral-700 font-light leading-relaxed mb-6">
                    At [Your Business Name], based right here in Austin, we understand the unique needs of women-owned businesses. We're passionate about creating websites that not only look stunning but also drive real results.
                  </p>
                  <p className="text-neutral-700 leading-relaxed mb-4">
                    Our website redesign services are tailored to help you:
                  </p>
                  <ul className="list-disc list-inside mt-4 text-neutral-700 leading-relaxed">
                    <li className="mb-2"><strong className="font-semibold">Modern & Responsive Design:</strong> We'll create a visually appealing and user-friendly website that looks fantastic on all devices.</li>
                    <li className="mb-2"><strong className="font-semibold">Improved User Experience:</strong> We'll optimize navigation and content flow to keep visitors engaged and guide them towards your goals.</li>
                    <li className="mb-2"><strong className="font-semibold">Strategic Lead Generation:</strong> We'll implement clear calls-to-action and effective lead capture strategies.</li>
                    <li className="mb-2"><strong className="font-semibold">Brand Alignment:</strong> We'll ensure your website accurately reflects your current brand identity and messaging.</li>
                    <li><strong className="font-semibold">SEO Optimization:</strong> We'll implement best practices to help your website get found by your ideal clients in Austin and beyond.</li>
                  </ul>
                  <a href="/contact" className="inline-block mt-8 bg-[#CFF098] text-black py-3 px-6 text-sm rounded-full transition duration-300 focus:outline-none focus:ring-2 focus:ring-[#CFF098] focus:ring-offset-1">
                    Let's Discuss Your Redesign
                  </a>
                </div>
                <div className="relative flex items-center justify-center">
                  {/* Image */}
                  <div className="absolute inset-y-0 right-0 w-1/2 md:w-auto">
                    <img
                      src={FeatureImage}
                      alt="Website Redesign Example"
                      className="h-full object-cover object-center"
                    />
                  </div>
                  {/* Empty div to maintain layout on smaller screens */}
                  <div className="hidden md:block w-64"></div>
                </div>
              </div>
            </div>

            {/* Call to Action */}
            <div className="mt-16 text-center">
              <h2 className="text-2xl font-semibold text-neutral-800 mb-6 uppercase tracking-wide">
                Ready to Elevate Your Online Presence?
              </h2>
              <p className="text-lg text-neutral-700 leading-relaxed mb-8">
                Don't let an outdated website hold your women-owned business back. Contact our Austin-based team today for a free consultation and let's discuss how a strategic redesign can help you attract more clients and achieve your business goals.
              </p>
              <a href="/contact" className="inline-block bg-[#CFF098] text-black py-3 px-8 text-sm rounded-full transition duration-300 focus:outline-none focus:ring-2 focus:ring-[#CFF098] focus:ring-offset-1">
                Schedule Your Free Consultation
              </a>
            </div>
          </div>
        </section>
        <div className="bg-[#2E2D2B]">
          <About />
        </div>
        <Footer />
      </section>
    </main>
  );
}

export default Blog2Signs;